import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../core/services/config.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UploadMissedActionDataValidationService {
  private options = { headers: new HttpHeaders().set('enctype', 'multipart/form-data') };
  constructor( private http: HttpClient,
    private configService: ConfigService) { }

    MissedActionDataAPI =  "/api/nwupldmsdactndtavldtnfle";
    getIdAPI =  "/api/gtapcnfgrtonbyid";

  ImportMissedActionData(data: any){
    return this.http.post(this.MissedActionDataAPI,data,this.options)
  }

  GetById(id: any) {
    return this.http.post(this.getIdAPI, id);
  }

  uploadFile(file: File, clientMasterID: number, missedActionDataDate: string, missedActionDataEndDate: string): Observable<any> {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    return new Observable(observer => {
      reader.onload = () => {
        const base64String = (reader.result as string).split(',')[1];
        this.sendBase64ToServer(base64String, clientMasterID, file.name, missedActionDataDate, missedActionDataEndDate).subscribe({
          next: (data) => observer.next(data),
          error: (error) => observer.error(error),
          complete: () => observer.complete()
        });
      };
    });
  }
  
  private sendBase64ToServer(base64String: string, clientMasterID: number, fileName: string, missedActionDataDate: string, missedActionDataEndDate: string): Observable<any> {
    const body = {
      UploadWorkbenchDataFileName: base64String,
      ClientMasterID: clientMasterID,
      FileName: fileName,
      MissedActionDataDate: missedActionDataDate,
      MissedActionDataEndDate: missedActionDataEndDate
    };
    return this.http.post<any>(this.MissedActionDataAPI, body);
  } 
}
